const evaluationRejectionType = {
  LosResultadosDeLaEvaluaciónNoMidenLoQueSeNecesitabaParaEvaluar: 13,
  LaMadrePadreOEncargadoNoEstanDeAcuerdoConLosResultadosDeLaEvaluacion: 14,
  LaEvaluacionNoReflejaLasHabilidadesODificultadesQuePresentaElEstudiante: 15,
  RazonDelReferido: 16,
  HistorialDelDesarrolloEvolutivo: 17,
  ConductaObservadaDuranteLaEvaluacion: 18,
  AnalisisDeFortalezasYDebilidades: 19,
  ImpresionDiagnostica: 20,
  RecomendacionesParaEscuelaYHogar: 21,
  AnejoIVPlanDeIntervencion: 22,
};

export default evaluationRejectionType;
